const AssignmentStatusBadge = ({ status }) => {
    const badgeClass = `assignment-status assignment-status-${String(status || "").toLowerCase()}`;
    return <span className={badgeClass}>{status || "PENDING"}</span>;
};

export default AssignmentStatusBadge;
